import React from 'react';
import cls from 'classnames';

import FlexRow from 'src/explore/elements/FlexRow';
import FlexCol from 'src/explore/elements/FlexCol';
import FormButton from 'src/explore/elements/FormButton';

const Success = ({ btnClass, email, onAccept }) => (
  <>
    <FlexRow>
      <FlexCol>
        <div className="text-center spec__forgot-password__success">
          {`Check your email ${email} and follow the link to complete your password reset.`}
        </div>
      </FlexCol>
    </FlexRow>
    <FlexRow>
      <FlexCol>
        <FormButton
          className={cls( btnClass, 'btn btn-block btn-secondary py-3 font-weight-bold' )}
          onClick={onAccept}
        >
          Got It!
        </FormButton>
      </FlexCol>
    </FlexRow>
  </>
);

export default Success;
